import $ from 'jquery'
window.jQuery = window.$ = $

jQuery.noConflict()

import Header from './modules/w-header'
import blockAccordion from './modules/w-block-accordion'
import moviesPreview from './modules/w-movies-preview'
import stripComingSoon from './modules/w-strip-coming-soon'
// import castSwiper from './modules/w-cast-swiper'
// import movieReminder from './modules/w-movie-reminder'
// import preOrderSwiper from './modules/w-pre-order-swiper'
// import stripPlayingNow from './modules/w-playing-now'
import bookingCalender from './modules/w-booking-calendar'
import bookingSeats from './modules/w-booking-seats'
// import popUpSwiper from './modules/w-pop-up-swiper'
import popUpAvatars from './modules/w-pop-up-avatars'
import contactLocations from './modules/w-contact-locations'
import bannerSwiper from './modules/w-s-banners-swiper'
import marketingSwiper from './modules/w-s-marketing-swiper'
import preFooterSwiper from './modules/w-pre-footer-swiper'
import downloadableFiles from './modules/w-downloadable-files'
import seeAlso from './modules/w-see-also'
import doubleSideSwiper from './modules/w-double-side'
import uniqueExperiences from './modules/w-unique-experiences'
import trailerButton from './modules/w-trailer-button'
import scrollToElement from './modules/w-scroll-to-element'
import movieReminderLink from './modules/w-movie-reminder-link'
import loginButton from './modules/w-login-button'
import copyToClipboard from './modules/w-copy-to-clipboard'
import wallet from './modules/w-wallet'

import constants from './lib/constants'
import { setViewportName, youtubeApi } from './lib/lib'

setViewportName()

window.addEventListener('resize', () => {
  setViewportName()
})

window.onYouTubeIframeAPIReady = () => {
  constants.youtube = true
  document.dispatchEvent(new Event('on-youtube-iframe-api-ready'))
}

window.isCaptchaReady = false

jQuery(document).on('captcha-ready', () => {
  window.isCaptchaReady = true
})

document.onreadystatechange = () => {
  if (!constants.captchaKey || !constants.captchaAction) {
    constants.captchaKey = window.sk
    constants.captchaAction = window.act
  }

  if (document.readyState === 'complete') {
    // document is ready. Do your stuff here
    constants.pageReady = true
    jQuery(document).trigger('document-ready')

    new Header(document.querySelector('.header'))

    document.querySelectorAll('.b-accordion').forEach((i) => {
      new blockAccordion(i)
    })

    document.querySelectorAll('.s-movies-preview').forEach((i) => {
      new moviesPreview(i)
    })

    document.querySelectorAll('.s-coming-soon').forEach((i) => {
      new stripComingSoon(i)
    })

    // document.querySelectorAll('.b-movie-reminder').forEach((i) => {
    //   new movieReminder(i)
    // })

    // document.querySelectorAll('.s-pre-order').forEach((i) => {
    //   new preOrderSwiper(i)
    // })

    // document.querySelectorAll('.s-playing-now').forEach((i) => {
    //   new stripPlayingNow(i)
    // })

    // document.querySelectorAll('.s-cast').forEach((i) => {
    //   new castSwiper(i)
    // })

    document.querySelectorAll('.b-calender__dates-holder').forEach((i) => {
      new bookingCalender(i)
    })
    document.querySelectorAll('.b-calender__seats-swiper').forEach((i) => {
      new bookingSeats(i)
    })
    // document.querySelectorAll('.b-pop-up').forEach((i) => {
    //   new popUpSwiper(i)
    // })
    document.querySelectorAll('.b-pop-up--avatars').forEach((i) => {
      new popUpAvatars(i)
    })
    document.querySelectorAll('.s-locations__directions').forEach((i) => {
      new contactLocations(i)
    })
    document.querySelectorAll('.s-ads-banner').forEach((i) => {
      new bannerSwiper(i)
    })
    document.querySelectorAll('.s-marketing').forEach((i) => {
      new marketingSwiper(i)
    })
    document.querySelectorAll('.s-pre-footer').forEach((i) => {
      new preFooterSwiper(i)
    })
    document.querySelectorAll('.s-downlodable-files').forEach((i) => {
      new downloadableFiles(i)
    })
    document.querySelectorAll('.s-mini-cards').forEach((i) => {
      new seeAlso(i)
    })
    document.querySelectorAll('.s-double-side').forEach((i) => {
      new doubleSideSwiper(i)
    })
    document.querySelectorAll('.s-unique-experiences').forEach((i) => {
      new uniqueExperiences(i)
    })
    document.querySelectorAll('[data-video-id]').forEach((i) => {
      new trailerButton(i)
    })
    document.querySelectorAll('[data-scroll-to]').forEach((i) => {
      new scrollToElement(i)
    })
    document.querySelectorAll('[data-movie-reminder-id]').forEach((i) => {
      new movieReminderLink(i)
    })
    document.querySelectorAll('[login-modal]').forEach((i) => {
      new loginButton(i)
    })
    document.querySelectorAll('.btn-copy-code').forEach((i) => {
      new copyToClipboard(i)
    })
    document.querySelectorAll('.b-wallet').forEach((i) => {
      new wallet(i)
    })

    // create youtube api
    youtubeApi()
  }
}
